import { Bell } from "lucide-react"
import { PlaceholderPage } from "./placeholder-page"

export function NotificationsSettingsPage() {
  return (
    <PlaceholderPage
      icon={Bell}
      title="Powiadomienia"
      description="Skonfiguruj preferencje powiadomie\u0144 \u2014 emailowe, push i w aplikacji."
    />
  )
}
